import { SEARCH_RESULTS_ERROR } from '@utils/constants';

export const GET_SEARCH_RESULTS_INIT =
  'CAT/NEXT/SEARCH/GET_SEARCH_RESULTS_INIT';
export const GET_SEARCH_RESULTS_SUCCESS =
  'CAT/NEXT/SEARCH/GET_SEARCH_RESULTS_SUCCESS';
export const GET_SEARCH_RESULTS_ERROR = SEARCH_RESULTS_ERROR;

export const STORE_SEARCH_META = 'CAT/NEXT/SEARCH/STORE_SEARCH_META';

export const GET_MORE_TRADES_RESULTS_INIT =
  'CAT/NEXT/SEARCH/GET_MORE_TRADES_RESULTS_INIT';
export const GET_MORE_TRADES_RESULTS_SUCCESS =
  'CAT/NEXT/SEARCH/GET_MORE_TRADES_RESULTS_SUCCESS';

export const SORT_SEARCH_RESULTS = 'CAT/NEXT/SEARCH/SORT_SEARCH_RESULTS';
export const SORT_SEARCH_RESULTS_SUCCESS =
  'CAT/NEXT/SEARCH/SORT_SEARCH_RESULTS_SUCCESS';
